import { Stat } from '../../api';
import MonthBarChart from './MonthBarChart';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getUnit(viewMode: string, day: number | undefined): string {
  if (viewMode == 'transfer') return 'MB';
  if (viewMode == 'notfound') return 'fails';
  return 'accesses';
}

function getTitle(viewMode: string, day: number): string {
  if (viewMode == 'transfer') return `Live HLS bandwidth usage (MB) by ${day ? 'hour' : 'day'}`;
  else if (viewMode == 'notfound') return `Live HLS download fails by ${day ? 'hour' : 'day'}`;
  else return `Live HLS accesses by ${day ? 'hour' : 'day'}`;
}

function getArrays(data: Stat, viewMode: string): Array<Array<number>> {
  if (viewMode == 'transfer')
    return [
      data?.live?.hls?.playlist?.bytes
        ? data.live.hls.playlist.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.live?.hls?.chunklist?.bytes
        ? data.live.hls.chunklist.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
      data?.live?.hls?.media?.bytes
        ? data.live.hls.media.bytes.map((value: number) => {
            return value / 1000000;
          })
        : [],
    ];
  else if (viewMode == 'notfound') return data?.live?.hls?.notFound ? [data.live.hls.notFound] : [[]];
  else return data?.live?.hls?.playlist?.count ? [data.live.hls.playlist.count] : [[]];
}

export default function MonthCameraLiveHlsChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  viewMode: string;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  onChangeDay: (d: number) => void;
}) {
  return <MonthBarChart getUnit={getUnit} getTitle={getTitle} getArrays={getArrays} {...props} />;
}
